import { MapContainer, TileLayer, Marker, Tooltip } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import { MessageCircle } from "lucide-react";
import { Reveal, SectionLabel } from "@/lib/Reveal";
import { BUSINESS, COVERAGE } from "@/lib/data";

const pin = L.divIcon({
  className: "",
  html: '<div style="width:12px;height:12px;background:#FF5500;border-radius:9999px;box-shadow:0 0 14px rgba(255,85,0,0.9);border:2px solid #0A0A0A"></div>',
  iconSize: [12, 12],
  iconAnchor: [6, 6],
});

export const Coverage = () => {
  return (
    <section id="coverage" data-testid="coverage-section" className="py-20 lg:py-28">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-12 grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
        <div>
          <Reveal><SectionLabel>12 / Where we work</SectionLabel></Reveal>
          <Reveal delay={0.1}>
            <h2 className="font-display font-extrabold uppercase tracking-tight text-3xl sm:text-4xl lg:text-5xl text-white mt-4">
              Exeter to Brixham.<br />We've got you covered.
            </h2>
          </Reveal>
          <Reveal delay={0.2}>
            <p className="mt-6 text-neutral-400 leading-relaxed max-w-md">
              Exeter, Newton Abbot, Teignmouth, Bovey Tracey, Chudleigh, Torquay,
              Paignton, Brixham, Ashburton, Liverton, Dawlish — and everywhere in
              between across South Devon.
            </p>
          </Reveal>
          <Reveal delay={0.3}>
            <a
              href={BUSINESS.whatsapp}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="coverage-whatsapp-btn"
              className="mt-8 inline-flex items-center gap-3 border border-neutral-700 hover:border-torch text-neutral-200 hover:text-torch font-display font-bold uppercase tracking-wide px-7 py-3.5 rounded-sm transition-colors"
            >
              <MessageCircle className="w-4 h-4" />
              Not sure if we cover you? Ask us
            </a>
          </Reveal>
        </div>

        <Reveal delay={0.2}>
          <div className="relative z-0 border border-neutral-800 hover:border-torch/50 rounded-sm overflow-hidden transition-colors" data-testid="coverage-map">
            <MapContainer
              center={[50.53, -3.585]}
              zoom={10}
              scrollWheelZoom={false}
              className="h-[320px] lg:h-[460px] w-full"
            >
              <TileLayer
                url="https://tile.openstreetmap.org/{z}/{x}/{y}.png"
                attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
              />
              {COVERAGE.map((t) => (
                <Marker key={t.name} position={t.coords} icon={pin}>
                  <Tooltip permanent direction="top" offset={[0, -10]} className="map-label">
                    {t.name}
                  </Tooltip>
                </Marker>
              ))}
            </MapContainer>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
